import { isSameDay } from 'date-fns';
import { DisplayFormattedDate } from 'components/common';

interface Props {
  startDate: string;
  endDate?: string;
}

const CalendarEventDateString = ({ startDate, endDate }: Props) => {
  const parsedStartDate = Date.parse(startDate);
  const parsedEndDate = endDate ? Date.parse(endDate) : null;

  return (
    <span>
      <span className="start-date">
        <DisplayFormattedDate date={parsedStartDate} />
      </span>
      <span className="start-time">
        <DisplayFormattedDate date={parsedStartDate} dateFormat="HH:mm" />
      </span>

      {endDate ? (
        <>
          <span className="separator">{'-'}</span>

          {!isSameDay(parsedStartDate, parsedEndDate) ? (
            <span className="end-date">
              <DisplayFormattedDate date={parsedEndDate} />
            </span>
          ) : null}
          <span className="end-time">
            <DisplayFormattedDate date={parsedEndDate} dateFormat="HH:mm" />
          </span>
        </>
      ) : null}

      <style jsx>{`
        .start-date,
        .end-date {
          margin-right: 7px;
        }
        .separator {
          margin: 0 5px;
        }
        .start-time,
        .end-time {
          font-weight: 400;
        }
      `}</style>
    </span>
  );
};

export default CalendarEventDateString;
